export const STATS = {
    // Home page
    all: {
        anchors: 173,
        borrowers: 18326,
        invoices: 411087,
        disbursed: 42851086262.33,
        aum: 3942225222.0,
    },
    // SaralPay Later
    bnpl: {
        anchors: 27,
        borrowers: 1881,
        invoices: 15477,
        disbursed: 11999290648.95,
        aum: 469580644.0,
    },
    // Vendor Finance
    vendor: {
        anchors: 13,
        borrowers: 90,
        invoices: 896,
        disbursed: 11600885712.7,
        aum: 1402360506.0,
    },
    // Supplychain finance
    scf: {
        anchors: 30,
        borrowers: 30,
        invoices: 1441,
        disbursed: 19250909900.68,
        aum: 2070284072.0,
    },
};
